import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./textarea.html";
import { BaseInput } from '../common/common';
class Textarea extends BaseInput {
  constructor(...args) {
    super(...args);
    this.maxLength = void 0;
    this.placeholder = void 0;
    this.subtitle = void 0;
    this.showRemainingCharacters = false;
    this.getCharactersRemainingText = () => `${this.remainingCharacters} characters remaining`;
    this.preventResize = false;
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.maxLength) {
      this.remainingCharacters = this.maxLength - (this.value ? this.value.length : 0);
    }
  }
  handleInput(event) {
    const target = event.target;
    if (this.maxLength) {
      this.remainingCharacters = this.maxLength - target.value.length;
    }
    this.value = target.value; // eslint-disable-line @lwc/lwc/no-api-reassignments
  }
  handleChange(event) {
    event.preventDefault();
    const target = event.target;
    // Re-Dispatch Event
    this.value = target.value; // eslint-disable-line @lwc/lwc/no-api-reassignments
    const newEvent = new CustomEvent(event.type, {
      composed: true,
      bubbles: true,
      cancelable: true,
      detail: this.value
    });
    this.dispatchEvent(newEvent);
  }
  get showRemainingCharactersInfo() {
    if (!this.maxLength) {
      return false;
    }
    return this.showRemainingCharacters;
  }
  get charactersRemainingDescription() {
    return this.getCharactersRemainingText();
  }
  get className() {
    if (this.preventResize) {
      return this.stateClassName + ' prevent-resize';
    }
    return this.stateClassName;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Textarea, {
  publicProps: {
    maxLength: {
      config: 0
    },
    placeholder: {
      config: 0
    },
    subtitle: {
      config: 0
    },
    showRemainingCharacters: {
      config: 0
    },
    getCharactersRemainingText: {
      config: 0
    },
    preventResize: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Textarea, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;